import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { readNotification } from "data/server_apis/notificationService";
import { getNotifications } from "data/server_apis/notificationService";
import { getNotificationCount } from "data/server_apis/notificationService";

const notificationAdapter = createEntityAdapter({
  selectId: (notification) => notification.id,
});

export const getNotificationCountThunk = createAsyncThunk(
  "notification/count",
  async (_, { rejectWithValue }) => {
    try {
      return (await getNotificationCount()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getNotificationsThunk = createAsyncThunk(
  "notification/notifications",
  async (page, { rejectWithValue }) => {
    try {
      return (await getNotifications(page)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const readNotificationThunk = createAsyncThunk(
  "notification/read_notifications",
  async (id, { rejectWithValue }) => {
    try {
      return (await readNotification(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: notificationAdapter.getInitialState({
    status: {},
    count: 0,
    page_size: 1,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotificationCountThunk.fulfilled, (state, action) => {
      state.status = { success: "get_count" };
      state.count = action.payload.count;
    });

    builder
      .addCase(readNotificationThunk.fulfilled, (state, action) => {
        state.status = { success: "read" };
        state.count -= 1;
        notificationAdapter.updateOne(state, {
          id: action.payload.id,
          changes: { ...action.payload, read: true },
        });
      })
      .addCase(readNotificationThunk.pending, (state, action) => {
        state.status = { loading: "read", id: action.meta.arg };
      });
    builder
      .addCase(getNotificationsThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getNotificationsThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.page_size = action.payload.total_pages;
        notificationAdapter.setAll(state, action.payload.results);
      });
  },
});

export const notificationSelector = notificationAdapter.getSelectors(
  (state) => state.notifications
);

export const {} = notificationsSlice.actions;

export default notificationsSlice.reducer;
